/**
 * @typedef {import('../interfaces/context/IArchivosAdjuntos.context.interface').IArchivosAdjuntosContext} IArchivosAdjuntosContext
 * @typedef {import('../interfaces/models/IArchivoAdjunto.interface').IArchivoAdjunto} IArchivoAdjunto
 */

import React, { createContext, useContext, useEffect, useState } from 'react';
import { node } from 'prop-types';
import ModalAdjuntarArchivos from '../components/ModalAdjuntarArchivos';

/**
 * @type {IArchivosAdjuntosContext}
 */
const contextDefaultValue = {
  archivoAdjunto: null,
  openModal: null,
  onEdit: null,
  setDownloadMode: null,
};

const ArchivosAdjuntosContext = createContext(contextDefaultValue);

/**
 * Componente que genera el Layout
 *
 * @component
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement}
 */
const ArchivosAdjuntosProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [editData, setEditData] = useState(null);
  const [archivoAdjunto, setArchivoAdjunto] = useState(null);

  /**
   *
   * @param {IArchivoAdjunto} data
   */
  const onEditData = (data) => {
    setEditData(data);
    setShow(true);
    setViewMode(false);
  };

  const onClose = () => {
    setEditData(null);
    setShow(false);
    setViewMode(false);
  };

  /**
   *
   * @param {IArchivoAdjunto} data
   */
  const onAccept = (data) => {
    setArchivoAdjunto(data);
    onClose();
  };

  const openModal = () => {
    setArchivoAdjunto(null);
    setShow(true);
  };

  useEffect(() => {
    if (!show) {
      setArchivoAdjunto(null);
    }
  }, [show]);

  const value = {
    archivoAdjunto,
    openModal,
    onEdit: (data) => onEditData(data),
    setDownloadMode: () => setViewMode(true),
  };

  return (
    <ArchivosAdjuntosContext.Provider value={value}>
      <ModalAdjuntarArchivos
        show={show}
        editData={editData}
        onAccept={onAccept}
        onClose={onClose}
        downloadMode={viewMode}
      />
      {children}
    </ArchivosAdjuntosContext.Provider>
  );
};

ArchivosAdjuntosProvider.propTypes = {
  children: node.isRequired,
};

const useArchivosAdjuntos = () => {
  const context = useContext(ArchivosAdjuntosContext);

  if (context === undefined) {
    throw new Error('useArchivosAdjuntos must be used within provider');
  }

  return context;
};

export { ArchivosAdjuntosProvider, ArchivosAdjuntosContext, useArchivosAdjuntos };
